import React from 'react';

/**
 * Registry of components that can be opened via URL redirects
 * 
 * Usage: ROUTABLE_COMPONENTS['ContactForm'] returns the ContactForm component
 */
export const ROUTABLE_COMPONENTS = {
  'ContactForm': React.lazy(() => import('../ContactForm')),
  // Add more routable components here as needed:
  // 'MediaViewer': React.lazy(() => import('../MediaViewer')),
  // 'LoginForm': React.lazy(() => import('../LoginForm')),
};

/**
 * Check if a component name is registered
 */
export const isRoutableComponent = (name) => {
  return name in ROUTABLE_COMPONENTS;
};

/**
 * Get a routable component by name
 */
export const getRoutableComponent = (name) => {
  return ROUTABLE_COMPONENTS[name] || null;
};








